import React, { useEffect, useState } from 'react'
import AccountInfo from '../AccountInfo'
import CartButton from '../CartButton'
import SearchBox from '../SearchBox'
import DrawerTipologiaCatalogo from './DrawerTipologiaCatalogo'
import { useSelector } from 'react-redux'
import { AppBar, Toolbar, Box, useMediaQuery, useTheme, Button, Alert } from '@mui/material'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import PopUp from '../PopUp'
import Login from '../../pages/Login'
import headerBackground from "../../images/fondo-cartulina-navbar.jpg";
import { trackLoginSection } from '../../helpers/analytics'

const Logo = `${process.env.PUBLIC_URL}/assets/logo-pizzini.png`

const styles = {
    toolBar: {
        color: 'black',
        textAlign: 'center',
        padding: "1px 0px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    toolBarMobile: {
        backgroundColor: 'white',
        color: 'black',
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        flexDirection: "column",
        padding: "10px"
    },
    navBarMargin: {
        marginRight: '1rem'
    },
    img: {
        width: '20rem',
        cursor: 'pointer'
    },
    root: {
        flexGrow: 0.3, '&& .Mui-selected': { fontSize: '13px' }
    },
    boxTitleNav: {
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        top: "55%",
        transform: "translate(-50%, -50%)"
    },
    titleNav: {
        fontSize: "90px", letterSpacing: "6px", cursor: "pointer", display: "block",
        transition: "opacity 0.5s ease", padding: 0, margin: 0,
    },
    labelActionRegister: {
        fontSize: "12px", minHeight: "40%", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        textDecoration: "underline",
        background: "white", padding: "3px 20px",
        display: "flex", alignItems: "center", justifyContent: "center"
    },
    buttonActionRegister: {
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "black", fontSize: "12px",
        padding: "1.5px 40px",
        opacity: ".7", boxShadow: "none",
        transition: "all 0.2s ease-in-out",
        // "&:hover": { opacity: ".7", backgroundColor: "black" }
    }
}


const LogginInfo = ({ isMobile }) => {
    return (
        isMobile ? <Box flexGrow={0.8} sx={{ display: "flex", alignContent: "center" }}>
            <CartButton />
            <AccountInfo />
        </Box> :
            <>
                <CartButton />
                <AccountInfo />
            </>
    )

}


const ButtonAccountSections = ({ pathname, text, title, isRegister = false, setOpenLogin, showLabel }) => {
    const setOpenPopUp = () => {
        setOpenLogin(true)
        trackLoginSection()
    }
    return (
        <Box>
            {showLabel ? <div style={styles.labelActionRegister}>
                {title}
            </div> : <div style={{ fontSize: "12px", minHeight: "48.5%" }} />}
            <Button component={isRegister ? Link : "button"}
                variant={showLabel ? "text" : "outlined"}
                color='inherit'
                onClick={() => !isRegister && setOpenPopUp()}
                sx={styles.buttonActionRegister}
                to={isRegister ? { pathname: "/register", state: { redir: pathname } } : undefined}>
                {text}
            </Button>
        </Box>
    )
}

export default function NavbarCatalogo() {
    const { pathname } = useLocation()
    const { isLoggedIn, roles } = useSelector(state => state.account)
    const [opacity, setOpacity] = useState(1)
    const [openLogin, setOpenLogin] = useState(false)

    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))
    const isHome = pathname === "/" || pathname.includes("/catalogo-details/")
    const navigate = useNavigate()

    const partes = pathname.split('/');
    const productId = partes[partes.length - 1];
    const isReportes = pathname.startsWith("/reportes");

    useEffect(() => {
        if (!isHome) return;

        // const handleScroll = () => {
        //     const scrollY = window.scrollY;
        //     const newOpacity = Math.max(1 - scrollY / 200, 0);
        //     setOpacity(newOpacity);
        // };

        // window.addEventListener('scroll', handleScroll);
        // return () => {
        //     window.removeEventListener('scroll', handleScroll);
        // };
    }, []);

    if (isLoggedIn) {
        if (!isLoggedIn) {
            return null
        }

        if (isReportes) {
            return (
                <AppBar position='static' sx={{ backgroundColor: "white", boxShadow: "none" }}>
                    <Toolbar style={mobile ? styles.toolBarMobile : styles.toolBar}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img src={Logo} style={{ width: mobile ? "70%" : "75%", cursor: "pointer" }} onClick={() => navigate("/")} />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <AccountInfo />
                        </Box>
                    </Toolbar>
                </AppBar>
            )
        }

        return (
            (roles && !roles.includes("Vendedor") && !roles.includes("Admin Ventas")) ?
                <AppBar position='static' sx={{
                    backgroundColor: "white", boxShadow: "none",
                }}>
                    <Toolbar style={mobile ? styles.toolBarMobile : styles.toolBar}>
                        {mobile && <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <img src={Logo} style={{ width: "70%", cursor: "pointer" }} onClick={() => navigate("/")} />
                        </Box>}
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <DrawerTipologiaCatalogo />
                            <SearchBox style={styles.navBarMargin} />
                        </Box>

                        {!mobile && <Box sx={styles.boxTitleNav}>
                            <img src={Logo} style={{ width: "75%", cursor: "pointer" }} onClick={() => navigate("/")} />
                        </Box>
                        }

                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            {<LogginInfo isMobile={mobile} theme={theme} />}
                            {/* <CartButtonCatalogo /> */}
                        </Box>
                    </Toolbar>
                </AppBar >
                : null
        )
    }

    return (
        <AppBar position='static' sx={{
            backgroundColor: "white", boxShadow: "none",
        }}>
            <Toolbar style={mobile ? styles.toolBarMobile : styles.toolBar}>
                {mobile && <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={Logo} style={{ width: "70%", cursor: "pointer" }} onClick={() => navigate("/")} />
                </Box>}
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <DrawerTipologiaCatalogo />
                    <SearchBox style={styles.navBarMargin} />
                </Box>

                {!mobile && <Box sx={styles.boxTitleNav}>
                    <img src={Logo} style={{ width: "75%", cursor: "pointer" }} onClick={() => navigate("/")} />
                </Box>
                }

                <Box>
                    <Box display="flex" gap="5px">
                        <ButtonAccountSections pathname={pathname} isRegister={true} title={"¿NO SOS CLIENTE?"} text={"REGISTRARTE"} showLabel />
                        <ButtonAccountSections setOpenLogin={setOpenLogin} title={"¿SOS CLIENTE?"} text={"INGRESAR"} />
                    </Box>
                    <PopUp msg={<Login isProductToNavigate={pathname.includes("/catalogo-details/") ? productId : null} handleClose={setOpenLogin} />} titleDisabled={true} buttonDisabled={true} setClose={setOpenLogin} open={openLogin} title='Iniciar Sesion' maxWidth='xs' />
                </Box>
            </Toolbar>
        </AppBar>

    )
}
